import Vue from 'vue'
import VueRouter from 'vue-router'

// eslint-disable-next-line no-unused-vars
import AuthenticatedGuard from '@/router/authenticated-guard'
// eslint-disable-next-line no-unused-vars
import CodeSplitGuard from '@/router/code-split-guard'

import DefaultRoutes from './default-routes'
import AccountRoutes from './account-routes'
import ProfileRoutes from './company-profile-routes'
import AdminRoutes from './admin-routes'
import BrokerAdminRoutes from './broker-admin-routes'
import RiskManagementRoutes from './risk-management-routes'
import PolicyAdminRoutes from './policy-admin-routes'
import DocumentRoutes from '@/router/document-routes'
import * as names from '@/router/route-names'
import BuildersRiskRoutes from '@/router/builders-risk-routes'
import FormsRoutes from '@/router/forms-routes'
import HighwingRoutes from '@/router/highwing-routes'
import BorRoutes from '@/router/bor-routes'
import SignatureRoutes from '@/router/signature-routes'
import AttorneyRoutes from './attorney-routes'
import RouteState from '@/router/route-state'

Vue.use(VueRouter)

const routes = [
  ...AccountRoutes,
  ...AttorneyRoutes,
  ...ProfileRoutes,
  ...DefaultRoutes,
  ...AdminRoutes,
  ...BrokerAdminRoutes,
  ...RiskManagementRoutes,
  ...PolicyAdminRoutes,
  ...DocumentRoutes,
  ...BuildersRiskRoutes,
  ...FormsRoutes,
  ...HighwingRoutes,
  ...BorRoutes,
  ...SignatureRoutes,
  {
    path: '/account-selector',
    name: names.ACCOUNT_SELECTOR,
    component: () => import('../views/AccountSelector.vue'),
  },
  {
    path: '/my-user',
    name: names.MANAGE_MY_USER,
    component: () => import('../views/user/ManageMyUser.vue'),
  },
  {
    path: '/resource-not-found',
    name: names.RESOURCE_NOT_FOUND,
    component: () => import('../views/ResourceNotFound.vue'),
  },
  {
    path: '/forbidden',
    name: names.FORBIDDEN,
    component: () => import('../views/ForbiddenAccess.vue'),
  },
]

// eslint-disable-next-line no-unused-vars
const scrollBehavior = (to, from, savedPosition) => {
  return { x: 0, y: 0 }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
})

AuthenticatedGuard.use(router)
CodeSplitGuard.use(router)
RouteState.use(router)

export default router
